import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Heaven is full fool",
  "description": "",
  "published": "2007-02-06T00:00:00.000Z",
  "redirect_from": ["/blog/heaven-is-full-fool/swizec/291"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So it has come to my attention today that heaven, known as Low Earth Orbit to normal people, `}<a parentName="p" {...{
        "href": "http://www.nytimes.com/2007/02/06/science/space/06orbi.html?ex=1328418000&en=16b9c6ba615c2e62&ei=5088&partner=rssnyt&emc=rss"
      }}>{`has officially reached critical mass`}</a>{` and we are in trouble if nothing is done about it.`}</p>
    <p>{`In other news, just because I'm pro linux, here is a `}<a parentName="p" {...{
        "href": "http://blogs.zdnet.com/threatchaos/?p=311"
      }}>{`lovely explanation`}</a>{` as to why exactly it is a lot better.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      